var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeco = function SvgHeco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8865\\u5145\\u9700\\u6C42",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8FDE\\u63A5\\u94B1\\u5305-\\u624B\\u673A",
    transform: "translate(-77.000000, -389.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F39\\u7A97",
    transform: "translate(18.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2\\u5907\\u4EFD",
    transform: "translate(20.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(39.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "heco",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 3.000000)",
    id: "\\u8DEF\\u5F84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,5.5394573 C8,2.9553776 6.69291824,0.732436966 5.69924793,0.00865379012 C5.69451983,0.00713641481 5.62366129,-0.0323151355 5.62995609,0.0708656239 C5.62995609,0.0723832069 5.62838239,0.0723832069 5.62838239,0.0739007899 C5.54649394,5.06452028 2.90089834,6.4164915 1.44581867,8.23885807 C-1.91157276,12.4435046 1.21117623,17.0532322 4.39062044,17.9044495 C6.17009952,18.3809096 3.9796045,17.0608478 3.69772303,14.2718736 C3.35599892,10.9018285 8,8.32989921 8,5.5394573 Z",
    fill: "#2D3338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52866244,7.01281083 C9.50640749,6.9988161 9.47564553,6.98955696 9.45339058,7.02206997 C9.39353768,7.66342435 8.67013794,9.03589727 7.75350752,10.2952815 C4.64446849,14.5677025 6.41618263,16.6280375 7.41322708,17.7340452 C7.99124809,18.3769545 7.41322708,17.7340452 8.8582796,17.0772824 C8.9711494,17.0261098 11.6800247,15.6505269 11.9724532,12.5166973 C12.2580457,9.48203226 10.2452262,7.56892459 9.52866244,7.01281083 Z",
    fill: "#01943F"
  }))))))))));
};

export { SvgHeco as ReactComponent };
export default __webpack_public_path__ + "3a8a490877f6222587c410fcde3c98c1.svg";